import { render } from "./NetworkPermissions.vue?vue&type=template&id=933d42ee"
import script from "./NetworkPermissions.vue?vue&type=script&lang=js"
export * from "./NetworkPermissions.vue?vue&type=script&lang=js"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__